export default "__VITE_ASSET__CsCdM_U___"